import { createContext, createElement, useCallback, useContext, useMemo, useState } from 'react';
import type { ReactNode } from 'react';
import type { MobilePreviewContextValue } from '../types/mobile-preview.types';

const MobilePreviewContext = createContext<MobilePreviewContextValue | null>(null);

interface MobilePreviewProviderProps {
  children: ReactNode;
}

export function MobilePreviewProvider({ children }: MobilePreviewProviderProps) {
  const [isMobilePreview, setIsMobilePreview] = useState(false);

  const enable = useCallback(() => {
    setIsMobilePreview(true);
  }, []);

  const disable = useCallback(() => {
    setIsMobilePreview(false);
  }, []);

  const toggle = useCallback(() => {
    setIsMobilePreview((open) => !open);
  }, []);

  const value = useMemo(
    () => ({ isMobilePreview, enable, disable, toggle }),
    [isMobilePreview, enable, disable, toggle],
  );

  return createElement(MobilePreviewContext.Provider, { value }, children);
}

export function useMobilePreview(): MobilePreviewContextValue {
  const context = useContext(MobilePreviewContext);
  if (context === null) {
    throw new Error('useMobilePreview must be used within MobilePreviewProvider');
  }
  return context;
}
